/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * EasySplitSettlements
 *
 */

import React, { memo, useState, useEffect, useRef, useReducer } from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams,
  Link,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import {
  Tab,
  Button,
  Popup,
  Conditional,
  AlertModal,
  Space,
  Text,
} from '@cashfree-intl/coherent';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import moment from 'moment';
import CustomIcon from 'components/CustomIcons';
import {
  addCurrencySymbol,
  copyToClipboard,
  roundOffNumber,
} from 'utils/common';
import {
  DEFAULT_CURRENT_PAGE,
  DEFAULT_LIMIT_OPTIONS,
  NAVIGATION_BAR_OPTIONS,
  PLACEHOLDER_TEXT,
  TX_STATUS_CLASSNAME,
  TIME_FORMATS,
  NOT_APPLICABLE,
} from 'utils/constants';
import OnDemandSettlementForm from 'components/OnDemandSettlementForm';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';

import { get, keyBy } from 'lodash';
import { INSTANT_SETTLEMENT } from 'containers/Settlements/constants';
import { selectMerchantDetailsSelector } from 'containers/DashboardContainer/selectors';
import DashboardFilters from 'containers/DashboardFilters';
import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import makeSelectEasySplitSettlements from './selectors';
import reducer, { liveSettlementReducer } from './reducer';
import saga from './saga';
import {
  formatDateToDateTimeFormat,
  getSmartReconEventLabel,
  getVenodorSettlementStatusTitle,
  sortSettlementComponentsList,
} from './utils';

import { basename } from '../../store';

import {
  createVendorBalanceTransferAction,
  disableLoaderAction,
  enableLoaderAction,
  generateSettlementReportAction,
  getOnDemandTableDataAction,
  getScheduledTableDataAction,
  getTransferBalanceAction,
  getTransferChargesAction,
  resetFiltersAction,
  resetPageAction,
  updateFiltersAction,
  getSettlementTimelineAction,
} from './actions';
import {
  HEADINGS,
  ON_DEMAND_TRANSFER_SUCCESS_MAPPING,
  VENDOR_SETTLEMENT_STATUS_TYPES,
  FETCH_LIVE_SETTLEMENT,
  SAVE_LIVE_SETTLEMENT,
} from './constants';
import { StyledTransferField } from './styled';
import liveTag from '../../images/live-tag.svg';
import StepProgress from './components/StepProgress';

export function EasySplitSettlements({
  menuSelected,
  activeNavigation,
  getTransferBalance,
  getTransferCharges,
  getOnDemandTableData,
  getScheduledTableData,
  updateFilters,
  resetFilters,
  twoFactorAuthentication,
  resetTwoFactorAuthentication,
  resetPage,
  enableLoader,
  disableLoader,
  createVendorBalanceTransfer,
  merchantDetails,
  getSettlementTimeline,
  easySplitSettlements: {
    filters,
    filtersForDisplay,
    isLoading,
    transferBalanceSuccessInfo,
  },
}) {
  useInjectReducer({ key: 'easySplitSettlements', reducer });
  useInjectSaga({ key: 'easySplitSettlements', saga });
  const [liveSettlementState, setLiveSettlementState] = useReducer(
    liveSettlementReducer,
    { settlementList: {}, loading: false },
  );

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { pathname, state = {} } = location;
  const { env = '' } = Object.fromEntries(searchParams);
  const [activeModalName, setActiveModalName] = useState('');
  const [currentNavigation, setCurrentNavigation] = useState(activeNavigation);
  const [tableData, updateTableData] = useState({});
  const [settlementData, setSettlementData] = useState();
  const isNavigatingToSettlementDetailsPage = useRef(false);

  const merchantLogo = get(merchantDetails, 'logoLarge', '');

  const initUpdateFilterOnMount = () => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!state) {
      let { locationState } = state;
      if (locationState) locationState = JSON.parse(locationState);
      return !!(locationState && locationState.updateFilter);
    }
    return false;
  };

  const [updateFilterOnMount, resetUpdateFilterOnMount] = useState(
    initUpdateFilterOnMount(),
  );

  const getHeading = () => HEADINGS.VENDOR_FOR_SETTLEMENT_V2_UI || [];

  const headings = getHeading();

  let FORMATTED_COLUMN_ID = formatColumns(headings);
  FORMATTED_COLUMN_ID = FORMATTED_COLUMN_ID.slice(1);

  const noRecordsObjScheduled = {
    icon: <CustomIcon componentName="BOX" />,
    text: 'No results found',
  };

  const noRecordsObjOnDemand = {
    icon: <CustomIcon componentName="BOX" />,
    text: <Text variant="h16">No On-Demand Settlement Initiated.</Text>,
    description: (
      <Text as="span" variant="b14">
        No settlements initiated. Click{' '}
        <Button
          link
          className="link-cta"
          type="button"
          onClick={() => handleSettleToVendorClick()}
          data-event-name="Link_SettleNow"
        >
          Settle Now
        </Button>{' '}
        to send your vendor their first on-demand settlement.
      </Text>
    ),
  };

  const handleNavigationClick = (e, data) => {
    Analytics.track(EVENTS.EASY_SPLIT[menuSelected][activeNavigation].VIEW);
    resetFilters();
    const { activeIndex, panes } = data;
    const navigationObj = navigationOptions.find(
      option => option.text === panes[activeIndex].menuItem,
    );
    if (navigationObj) {
      navigate(
        `${basename}pg/easy-split/settlements/${navigationObj.key}${
          env ? `?env=${env}` : ''
        }`,
      );
      setCurrentNavigation(navigationObj?.text);
    }
    updateTableData({});
  };

  const handleRowClick = rowData => {
    Analytics.track(
      EVENTS.EASY_SPLIT[menuSelected][activeNavigation].VIEW_SETTLEMENT_DETAILS,
    );

    isNavigatingToSettlementDetailsPage.current = true;
    navigate(
      `${location.pathname}/settlement-details?settlementId=${
        rowData.id
      }&activeNavigation=${activeNavigation}${env ? `&env=${env}` : ''}`,
    );
  };

  const matchedParams = pathname.split('/').slice(-1)[0];

  const navigationOptions = NAVIGATION_BAR_OPTIONS[menuSelected];

  const panes = navigationOptions.map(navigation => ({
    key: navigation.key,
    menuItem: navigation.text,
    render: () => null,
  }));

  // const showPopupOnHover = (cellValue, rowData, key) => {
  //   const popupGrid = gridData => (
  //     <div className="settlements-popup-grid">
  //       {gridData.map((element, index) => (
  //         <div className={`grid-item item-${index + 1}`}>
  //           <Text variant="b12" bold color="bodyLight">
  //             {element[0]}
  //           </Text>
  //           <Text variant="b12" bold color="bodyLight">
  //             {element[1]}
  //           </Text>
  //         </div>
  //       ))}
  //     </div>
  //   );

  //   const vendorAdjustment = () => {
  //     const gridData = [
  //       ['Other Adjustment Amount', rowData.otherAdjustmentAmount()],
  //       ['Settlement Service Charges', rowData.serviceCharge()],
  //       ['Settlement Service Tax', rowData.serviceTax()],
  //       ['Billed To', rowData.billedTo],
  //     ];
  //     return <div className="vendor-adjustment">{popupGrid(gridData)}</div>;
  //   };

  //   if (activeNavigation === 'Scheduled' && key === 'adjustmentAmount') {
  //     return (
  //       <Popup
  //         content={vendorAdjustment()}
  //         className="settlements-column-breakup-popup"
  //         trigger={<span className="underline">{cellValue()}</span>}
  //         position="top"
  //       />
  //     );
  //   }
  //   return cellValue();
  // };

  const handleSettleToVendorClick = () => {
    setActiveModalName('ON_DEMAND_SETTLEMENT_FORM');
  };

  let activePageIndex = panes.findIndex(ele => ele.key === matchedParams);
  activePageIndex = activePageIndex < 0 ? 0 : activePageIndex;

  const rowClicked = useRef(false);
  const formatDateFilters = obj => obj.range.map(str => moment(str).toDate());

  useEffect(() => {
    if (updateFilterOnMount) {
      // call the update filter action with appropriate object
      let { locationState } = state;
      locationState = JSON.parse(locationState);

      if (locationState.dateFilters && locationState.dateFilters.range) {
        locationState.dateFilters.range = formatDateFilters(
          locationState.dateFilters,
        );
      }

      updateFilters({
        ...locationState,
        activeNavigation,
      });
      // reset the updateFilterOnMount flag to false
      resetUpdateFilterOnMount(false);
    } else {
      getTableData();
    }
  }, [activeNavigation, filters, searchParams.get('env')]);

  useEffect(() => {
    if (twoFactorAuthentication) {
      getTableData();
      resetTwoFactorAuthentication(false);
    }
    return () => {
      if (!rowClicked.current) resetFilters();
    };
  }, [twoFactorAuthentication]);

  useEffect(() => {
    if (!isLoading && settlementData) {
      let formattedData = [];
      const pageData = JSON.parse(JSON.stringify(settlementData));
      switch (activeNavigation) {
        case 'On-Demand': {
          const vendorData =
            pageData && pageData.content ? pageData.content : [];
          formattedData = vendorData.map(rowData => ({
            ...rowData,
            unFormattedData: rowData,
            id: rowData.payoutId,
            settlementTypeCTA: () => (
              <>
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <img
                    src={liveTag}
                    alt="live settlement"
                    className="live-tag-fixed"
                  />
                </Conditional>
                <Conditional if={rowData.settlementType === INSTANT_SETTLEMENT}>
                  <CustomIcon
                    componentName="LIGHTNING"
                    className="ml-2"
                    dimension="18px"
                  />
                </Conditional>
              </>
            ),
            addedOn: () => (
              <div className="flex">
                <span className="table-content">
                  {moment(rowData.addedOn).format('DD MMM YYYY,')}
                  <br />
                  {moment(rowData.addedOn).format('hh:mm A')}
                </span>
              </div>
            ),
            period: () => (
              <div className="flex">
                <span className="table-content">
                  {moment(rowData.periodStart).format('Do MMM YYYY, hh:mm A')} -{' '}
                  <br />
                  {moment(rowData.periodEnd).format('Do MMM YYYY, hh:mm A')}
                </span>
              </div>
            ),
            utr: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">{rowData.utr}</span>
                {rowData.utr && rowData.utr !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={e => {
                      Analytics.track(
                        EVENTS.EASY_SPLIT[menuSelected][activeNavigation]
                          .UTR_COPIED,
                      );
                      copyToClipboard(rowData.utr)(e);
                    }}
                  />
                ) : (
                  PLACEHOLDER_TEXT
                )}
              </div>
            ),
            settlementStatus: () => (
              <span className={`${TX_STATUS_CLASSNAME[rowData.status] || ''}`}>
                {!(
                  (rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.FAILED ||
                    rowData.status ===
                      VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED) &&
                  rowData.detailedFailureMessage
                ) ? (
                  getVenodorSettlementStatusTitle(rowData.status)
                ) : (
                  <Popup
                    content={rowData.detailedFailureMessage}
                    trigger={
                      <span>
                        {getVenodorSettlementStatusTitle(rowData.status)}
                        <span className="mr-left-4 small-svg">
                          <CustomIcon
                            componentName="INFO"
                            fill={
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED ||
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.FAILED
                                ? 'var(--DANGER)'
                                : 'var(--SUCCESS_STATUS)'
                            }
                          />
                        </span>
                      </span>
                    }
                    position="bottom center"
                  />
                )}
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <Conditional if={liveSettlementState.loading}>
                    <div className="ui active mini inline loader mr-left-4" />
                  </Conditional>
                  <Conditional
                    if={
                      !liveSettlementState.loading &&
                      liveSettlementState.settlementList[rowData.payoutId]
                    }
                  >
                    <Conditional
                      if={
                        !liveSettlementState.settlementList[rowData.payoutId]
                          ?.estimatedTimetoArrival
                      }
                    >
                      <Text
                        variant="b12"
                        color="bodyLight"
                        className="font-normal mr-left-7 display-inline"
                      >
                        Expected Credit Time :{' '}
                        {formatDateToDateTimeFormat(
                          liveSettlementState.settlementList[rowData.payoutId]
                            ?.estimatedTimeToArrival,
                          TIME_FORMATS.DATE_MONTH_YEAR_WITH_TIME,
                        )}
                      </Text>
                    </Conditional>
                    <StepProgress
                      merchantLogo={merchantLogo}
                      settlementData={
                        liveSettlementState.settlementList[rowData.payoutId]
                      }
                    />
                  </Conditional>
                </Conditional>
              </span>
            ),
            settledAmount: () => (
              <span>
                {rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED
                  ? NOT_APPLICABLE
                  : addCurrencySymbol(
                      roundOffNumber(rowData.settledAmount),
                    ) /* eslint-disable-line prettier/prettier */}
                <Conditional
                  if={
                    rowData.settlementDetailedView?.settlementComponentsList
                      ?.length &&
                    ![
                      VENDOR_SETTLEMENT_STATUS_TYPES.FAILED,
                      VENDOR_SETTLEMENT_STATUS_TYPES.PENDING,
                      VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED,
                    ].includes(rowData.status)
                  }
                >
                  <div className="small-svg">
                    <Popup
                      trigger={
                        <span>
                          <Text
                            color="info"
                            variant="b12"
                            className="smart-recon-text small-text"
                          >
                            Smart recon{' '}
                          </Text>
                          <span>
                            <CustomIcon
                              componentName="INFO"
                              fill="var(--INFO)"
                            />
                          </span>
                        </span>
                      }
                      position="bottom center"
                      hoverable
                    >
                      <div className="pd-12 smart-recon-table">
                        {sortSettlementComponentsList(
                          rowData.settlementDetailedView
                            ?.settlementComponentsList,
                        ).map(breakDownDetails => {
                          const { event, eventType, amount } = breakDownDetails;
                          const label = getSmartReconEventLabel(event);

                          return (
                            <>
                              <Space
                                justifyContent="space-between"
                                alignItems="center"
                                key={event}
                                className="mr-top-12 mr-btm-12"
                              >
                                <Text
                                  color="bodyLight"
                                  variant="b12"
                                  className="font-normal"
                                >
                                  {label}
                                </Text>
                                <Text
                                  color={
                                    eventType === 'DEBIT' ? 'danger' : 'success'
                                  }
                                  variant="b14"
                                  strong
                                  className="font-normal"
                                >
                                  {addCurrencySymbol(roundOffNumber(amount))}
                                </Text>
                              </Space>
                              <hr />
                            </>
                          );
                        })}
                        <Text
                          variant="b12"
                          className="font-normal tiny-text line-ht-12"
                        >
                          Service charge and tax will be levied based on your
                          usage and plan type (postpaid/ prepaid). Check the{' '}
                          <Link
                            href={`${
                              location.pathname
                            }/settlement-details?settlementId=${
                              rowData.settlementId
                            }${env ? `&env=${env}` : ''}`}
                          >
                            {' '}
                            View Details
                          </Link>{' '}
                          section to know the detailed breakup.
                        </Text>
                      </div>
                    </Popup>
                  </div>
                </Conditional>
              </span>
            ),
          }));

          break;
        }
        case 'Scheduled': {
          const vendorData =
            pageData && pageData.content ? pageData.content : [];
          formattedData = vendorData.map(rowData => ({
            ...rowData,
            unFormattedData: rowData,
            id: rowData.payoutId,
            settlementTypeCTA: () => (
              <>
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <img
                    src={liveTag}
                    alt="live settlement"
                    className="live-tag-fixed"
                  />
                </Conditional>
                <Conditional if={rowData.settlementType === INSTANT_SETTLEMENT}>
                  <CustomIcon
                    componentName="LIGHTNING"
                    className="ml-2"
                    dimension="18px"
                  />
                </Conditional>
              </>
            ),
            addedOn: () => (
              <div className="flex">
                <span className="table-content">
                  {moment(rowData.addedOn).format('DD MMM YYYY,')}
                  <br />
                  {moment(rowData.addedOn).format('hh:mm A')}
                </span>
              </div>
            ),
            payoutId: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">{rowData.payoutId}</span>
                {rowData.payoutId && rowData.payoutId !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={e => {
                      Analytics.track(
                        EVENTS.EASY_SPLIT[menuSelected][activeNavigation]
                          .SETTLEMENT_ID_COPIED,
                      );
                      copyToClipboard(rowData.payoutId)(e);
                    }}
                  />
                ) : (
                  PLACEHOLDER_TEXT
                )}
              </div>
            ),
            merchantVendorId: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">
                  {rowData.merchantVendorId}
                </span>
                {rowData.merchantVendorId &&
                rowData.merchantVendorId !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={e => {
                      Analytics.track(
                        EVENTS.EASY_SPLIT[menuSelected][activeNavigation]
                          .VENDOR_ID_COPIED,
                      );
                      copyToClipboard(rowData.merchantVendorId)(e);
                    }}
                  />
                ) : (
                  PLACEHOLDER_TEXT
                )}
              </div>
            ),
            utr: () => (
              <div className="flex copy-to-clipboard-wrapper">
                <span className="table-content">{rowData.utr}</span>
                {rowData.utr && rowData.utr !== 'N/A' ? (
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={e => {
                      Analytics.track(
                        EVENTS.EASY_SPLIT[menuSelected][activeNavigation]
                          .UTR_COPIED,
                      );
                      copyToClipboard(rowData.utr)(e);
                    }}
                  />
                ) : (
                  PLACEHOLDER_TEXT
                )}
              </div>
            ),
            settlementStatus: () => (
              <span className={`${TX_STATUS_CLASSNAME[rowData.status] || ''}`}>
                {!(
                  (rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.FAILED ||
                    rowData.status ===
                      VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED) &&
                  rowData.detailedFailureMessage
                ) ? (
                  getVenodorSettlementStatusTitle(rowData.status)
                ) : (
                  <Popup
                    content={rowData.detailedFailureMessage}
                    trigger={
                      <span>
                        {getVenodorSettlementStatusTitle(rowData.status)}
                        <span className="mr-left-4 small-svg">
                          <CustomIcon
                            componentName="INFO"
                            fill={
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED ||
                              rowData.status ===
                                VENDOR_SETTLEMENT_STATUS_TYPES.FAILED
                                ? 'var(--DANGER)'
                                : 'var(--SUCCESS_STATUS)'
                            }
                          />
                        </span>
                      </span>
                    }
                    position="bottom center"
                  />
                )}
                <Conditional
                  if={
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
                    rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
                  }
                >
                  <Conditional if={liveSettlementState.loading}>
                    <div className="ui active mini inline loader mr-left-4" />
                  </Conditional>
                  <Conditional
                    if={
                      !liveSettlementState.loading &&
                      liveSettlementState.settlementList[rowData.payoutId]
                    }
                  >
                    <Conditional
                      if={
                        !liveSettlementState.settlementList[rowData.payoutId]
                          ?.estimatedTimetoArrival
                      }
                    >
                      <Text
                        variant="b12"
                        color="bodyLight"
                        className="font-normal mr-left-7 display-inline"
                      >
                        Expected Credit Time :{' '}
                        {formatDateToDateTimeFormat(
                          liveSettlementState.settlementList[rowData.payoutId]
                            ?.estimatedTimeToArrival,
                          TIME_FORMATS.DATE_MONTH_YEAR_WITH_TIME,
                        )}
                      </Text>
                    </Conditional>
                    <StepProgress
                      merchantLogo={merchantLogo}
                      settlementData={
                        liveSettlementState.settlementList[rowData.payoutId]
                      }
                    />
                  </Conditional>
                </Conditional>
              </span>
            ),
            settledAmount: () => (
              <span>
                {rowData.status === VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED
                  ? NOT_APPLICABLE
                  : addCurrencySymbol(
                      roundOffNumber(rowData.settledAmount),
                    ) /* eslint-disable-line prettier/prettier */}
                <Conditional
                  if={
                    rowData.settlementDetailedView?.settlementComponentsList
                      ?.length &&
                    ![
                      VENDOR_SETTLEMENT_STATUS_TYPES.FAILED,
                      VENDOR_SETTLEMENT_STATUS_TYPES.PENDING,
                      VENDOR_SETTLEMENT_STATUS_TYPES.REVERSED,
                    ].includes(rowData.status)
                  }
                >
                  <div className="small-svg">
                    <Popup
                      trigger={
                        <span>
                          <Text
                            color="info"
                            variant="b12"
                            className="smart-recon-text small-text"
                          >
                            Smart recon{' '}
                          </Text>
                          <span>
                            <CustomIcon
                              componentName="INFO"
                              fill="var(--INFO)"
                            />
                          </span>
                        </span>
                      }
                      position="bottom center"
                      hoverable
                    >
                      <div className="pd-12 smart-recon-table">
                        {sortSettlementComponentsList(
                          rowData.settlementDetailedView
                            ?.settlementComponentsList,
                        ).map(breakDownDetails => {
                          const { event, eventType, amount } = breakDownDetails;
                          const label = getSmartReconEventLabel(event);

                          return (
                            <>
                              <Space
                                justifyContent="space-between"
                                alignItems="center"
                                key={event}
                                className="mr-top-12 mr-btm-12"
                              >
                                <Text
                                  color="bodyLight"
                                  variant="b12"
                                  className="font-normal"
                                >
                                  {label}
                                </Text>
                                <Text
                                  color={
                                    eventType === 'DEBIT' ? 'danger' : 'success'
                                  }
                                  variant="b14"
                                  strong
                                  className="font-normal"
                                >
                                  {addCurrencySymbol(roundOffNumber(amount))}
                                </Text>
                              </Space>
                              <hr />
                            </>
                          );
                        })}
                        <Text
                          variant="b12"
                          className="font-normal tiny-text line-ht-12"
                        >
                          Service charge and tax will be levied based on your
                          usage and plan type (postpaid/ prepaid). Check the{' '}
                          <Link
                            href={`${
                              location.pathname
                            }/settlement-details?settlementId=${
                              rowData.settlementId
                            }${env ? `&env=${env}` : ''}`}
                          >
                            {' '}
                            View Details
                          </Link>{' '}
                          section to know the detailed breakup.
                        </Text>
                      </div>
                    </Popup>
                  </div>
                </Conditional>
              </span>
            ),
          }));
          break;
        }
        default:
          break;
      }
      const hasPrev = filters.pageNo !== 1;
      const hasNext = pageData?.content.length >= filters.pageSize;

      updateTableData({
        currentPageRowData: formattedData,
        hasPrev,
        hasNext,
      });
      disableLoader();
    }
  }, [isLoading, settlementData, liveSettlementState.loading, merchantLogo]);

  const onPageChange = type => {
    const options = { ...filters, currentNavigation, filtersForDisplay };
    switch (type) {
      case 'NEXT':
        options.pageNo += 1;
        break;
      case 'PREV':
        options.pageNo -= 1;
        break;
      default:
        break;
    }
    updateFilters(options);
  };

  const onLimitChange = (e, limitChangeData) => {
    Analytics.track(
      EVENTS.EASY_SPLIT[menuSelected][activeNavigation].PAGE_SIZE,
    );
    const options = {
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      pageSize: parseInt(limitChangeData.value, 10),
      activeNavigation,
      filtersForDisplay,
    };
    updateFilters(options);
  };

  const formatTableData = data => {
    setSettlementData(data);
    const status = [
      VENDOR_SETTLEMENT_STATUS_TYPES.CREATED,
      VENDOR_SETTLEMENT_STATUS_TYPES.PENDING,
    ];
    const inProgressSettlements = data?.content
      .filter(settlement => status.includes(settlement.status))
      .map(settlement => settlement.payoutId);

    if (inProgressSettlements?.length) {
      setLiveSettlementState({ type: FETCH_LIVE_SETTLEMENT });
      getSettlementTimeline({
        inProgressSettlements,
        cb: getSettlementTimelineCallback,
      });
    }
  };

  const getSettlementTimelineCallback = response => {
    if (response.error) {
      setLiveSettlementState({ type: SAVE_LIVE_SETTLEMENT, data: {} });
      return;
    }
    const dataKeyedBySettlementId = keyBy(response, 'settlementId');

    setLiveSettlementState({
      type: SAVE_LIVE_SETTLEMENT,
      data: dataKeyedBySettlementId,
    });
  };

  const getTableData = () => {
    enableLoader();
    const { appliedFilters, pageNo, pageSize } = filters;

    const formattedFilterObj = {
      ...appliedFilters,
      pageNo: pageNo - 1,
      pageSize,
    };

    if (
      appliedFilters.search &&
      appliedFilters.search.type &&
      appliedFilters.search.value &&
      appliedFilters.search.value.trim()
    ) {
      const {
        search: { type, value },
      } = appliedFilters;
      formattedFilterObj[type] = value.trim();
      delete formattedFilterObj.search;
    }
    if (formattedFilterObj.startOrderAmount) {
      formattedFilterObj.settlementAmountMin =
        formattedFilterObj.startOrderAmount;
      delete formattedFilterObj.startOrderAmount;
    }
    if (formattedFilterObj.endOrderAmount) {
      formattedFilterObj.settlementAmountMax =
        formattedFilterObj.endOrderAmount;
      delete formattedFilterObj.endOrderAmount;
    }

    if (activeNavigation === 'Scheduled') {
      getScheduledTableData({
        options: { ...formattedFilterObj, includeSkipSettlements: false },
        cb: formatTableData,
      });
    } else {
      getOnDemandTableData({
        options: formattedFilterObj,
        cb: formatTableData,
      });
    }
  };

  const {
    currentPageRowData = [],
    hasPrev = false,
    hasNext = false,
  } = tableData;

  const closeModal = () => {
    setActiveModalName('');
    getTableData();
  };

  const handleBalanceTransfer = data => {
    const { actions } = data;
    createVendorBalanceTransfer({
      ...data,
      cb: () => {
        actions.setSubmitting(false);
        setActiveModalName('TRANSFER_INITIATED_SUCCESS');
      },
    });
  };

  return (
    <>
      <Tab
        activeIndex={activePageIndex}
        panes={panes}
        menu={{ secondary: true, pointing: true }}
        onTabChange={handleNavigationClick}
      />

      <div className="dashboard-filters-wrapper mt-2">
        <DashboardFilters
          menuSelected={menuSelected}
          filters={filters}
          filtersForDisplay={filtersForDisplay}
          activeNavigation={activeNavigation}
          getTableDataFn={getTableData}
          resetFilterFn={resetFilters}
          resetPageFn={resetPage}
          updateFilterFn={updateFilters}
        />
        <Conditional if={activeNavigation === 'On-Demand'}>
          <div className="tab-cta-wrapper">
            <Button
              primary
              onClick={handleSettleToVendorClick}
              data-event-name="Primary_Button_SettleToVendor"
            >
              Settle to Vendor
            </Button>
          </div>
        </Conditional>
      </div>
      {activeNavigation && (
        <PaginatedTable
          data={currentPageRowData}
          emptyTableComponent={
            currentNavigation === 'On-Demand'
              ? noRecordsObjOnDemand
              : noRecordsObjScheduled
          }
          tableHeading={FORMATTED_COLUMN_ID}
          limit={filters.pageSize}
          limitOptions={DEFAULT_LIMIT_OPTIONS}
          hasPrev={hasPrev}
          hasNext={hasNext}
          currentPage={filters.pageNo}
          currentPageCount={currentPageRowData.length}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          onRowClick={handleRowClick}
          fetching={isLoading}
        />
      )}
      <Conditional if={activeModalName === 'ON_DEMAND_SETTLEMENT_FORM'}>
        <OnDemandSettlementForm
          onClose={closeModal}
          getTransferBalance={getTransferBalance}
          getTransferCharges={getTransferCharges}
          handleBalanceTransfer={handleBalanceTransfer}
        />
      </Conditional>
      <Conditional if={activeModalName === 'TRANSFER_INITIATED_SUCCESS'}>
        <AlertModal
          type="success"
          title="On Demand Transfer Initiated Successfully"
          onClose={closeModal}
          eventNameOnClose="On_Demand_Transfer_Initiated_Successfully_Close"
        >
          <Space direction="column" gap={4}>
            <Text variant="b14" color="bodyLight">
              Your vendor will receive the settlements within 1-3 hrs.
            </Text>
            <Space direction="column" gap={2} className="ml-8">
              {Object.keys(ON_DEMAND_TRANSFER_SUCCESS_MAPPING).map(obj => (
                <Space key={obj}>
                  <StyledTransferField color="bodyLight" variant="b14">
                    {ON_DEMAND_TRANSFER_SUCCESS_MAPPING[obj]}
                  </StyledTransferField>
                  <Text variant="b14" strong>
                    {transferBalanceSuccessInfo[obj] || '--'}
                  </Text>
                </Space>
              ))}
            </Space>
          </Space>
        </AlertModal>
      </Conditional>
    </>
  );
}

EasySplitSettlements.propTypes = {
  easySplitSettlements: PropTypes.object.isRequired,
  menuSelected: PropTypes.string.isRequired,
  activeNavigation: PropTypes.string.isRequired,
  getTransferBalance: PropTypes.func.isRequired,
  getTransferCharges: PropTypes.func.isRequired,
  getOnDemandTableData: PropTypes.func.isRequired,
  getScheduledTableData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  twoFactorAuthentication: PropTypes.bool.isRequired,
  resetTwoFactorAuthentication: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
  enableLoader: PropTypes.func.isRequired,
  disableLoader: PropTypes.func.isRequired,
  createVendorBalanceTransfer: PropTypes.func.isRequired,
  merchantDetails: PropTypes.any,
  getSettlementTimeline: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  easySplitSettlements: makeSelectEasySplitSettlements(),
  merchantDetails: selectMerchantDetailsSelector(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTransferBalance: data => dispatch(getTransferBalanceAction(data)),
    getTransferCharges: data => dispatch(getTransferChargesAction(data)),
    getOnDemandTableData: data => dispatch(getOnDemandTableDataAction(data)),
    getScheduledTableData: data => dispatch(getScheduledTableDataAction(data)),
    resetFilters: () => dispatch(resetFiltersAction()),
    resetPage: () => dispatch(resetPageAction()),
    updateFilters: data => dispatch(updateFiltersAction(data)),
    generateSettlementReport: data =>
      dispatch(generateSettlementReportAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
    createVendorBalanceTransfer: data =>
      dispatch(createVendorBalanceTransferAction(data)),
    getSettlementTimeline: data => dispatch(getSettlementTimelineAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(EasySplitSettlements);
